import React, { useEffect, useRef } from 'react';
import CBTooltip from '@cb/apricot/CBTooltip';
import { useUID } from 'react-uid';
export const tooltipPlacements = ['top', 'right', 'bottom', 'left'];
export const Tooltip = ({ tooltipId, children, trigger, shadowRoot = false, triggerEvent = 'hover focus', light, repetitiveLabel = false, placement = 'top', className, onShow = null, onHide = null, cbRef, }) => {
    const ref = useRef(null);
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    tooltipId = tooltipId || `apricot_tooltip_${uid}`;
    useEffect(() => {
        var _a, _b;
        const reference = typeof trigger === 'string' ? document.getElementById(trigger) : trigger;
        reference && reference.setAttribute('aria-controls', tooltipId);
        const tooltip = CBTooltip({
            elem: reference,
            trigger: triggerEvent,
            markup: false,
            html: true,
            placement,
            shadowRoot,
            title: ((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.innerHTML) || '',
            style: light ? 'cb-tooltip-light' : className,
            repetitiveLabel,
            onShow,
            onHide,
        });
        if (cbRef) {
            // eslint-disable-next-line no-param-reassign
            cbRef.current = tooltip;
        }
        return () => {
            if (tooltip) {
                tooltip.destroy();
            }
        };
    }, []);
    return (React.createElement("div", { key: tooltipId, id: tooltipId, className: "cb-tooltip hidden", role: "tooltip", "data-cbtrack-comp": "apricot-react:tooltip", ref: ref },
        React.createElement("div", { className: "cb-tooltip-inner" }, children)));
};
//# sourceMappingURL=Tooltip.js.map